<template>
  <v-app id="app">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
    mounted() {
        this.initForceChangePwd();
        const token = localStorage.getItem('token');
        const loginToken = localStorage.getItem('loginToken');
        if (token && loginToken) {
            this.isLogin();
        }
    },
    methods: {
        initForceChangePwd() {
            const forceChangePwd = localStorage.getItem('forceChangePwd') === 'true';
            this.$store.state.user.forceChangePwd = forceChangePwd;
        },
        isLogin(){
            const token = localStorage.getItem('token');
            const loginToken = localStorage.getItem('loginToken');
            this.axios.get("/loginapi/getLoginInfo", {
                headers: {
                    'Authorization': token,
                    'LoginToken': loginToken
                }
            }).then(res => {
                if (res.data.status === 500){
                    if (!this.$store.state.user.logined) {
                        this.clearLoginInfo();
                        if (this.$router.history.current.path !== "/") {
                            this.$router.push("/");
                            console.log("app.vue--isLogin()500", res.data.data, this.$router)
                        }
                    }
                } else if (res.data.status === 200){
                        if (this.$store.state.user.forceChangePwd) {
                            this.$store.state.user.logined = false;
                            this.$store.state.user.userId = '';
                        } else {
                            this.axios({
                                method: 'get',
                                url: '/demandService/customer/getVipCustomer',
                                params: {

                                }
                            }).then(response => {
                                if(response.data.data!=undefined)
                                {
                                    this.$store.state.user.isBigCustomer=true
                                    this.$store.state.user.authorizationCode=response.data.data.obsAccountUrl
                                    this.$store.state.user.obsKey=response.data.data.key
                                }
                                else{
                                    this.$store.state.user.isBigCustomer=false
                                }
                            })
                            this.utils.saveUserInfo(res, this.$store.state, this.$router);
                        }
                    } else {
                    if (!this.$store.state.user.logined) {
                        this.clearLoginInfo();
                        if (this.$router.history.current.path !== "/") {
                            this.$router.push("/");
                        }
                    }
                    console.log("app.vue--isLogin()其他", res.data);
                }
            }).catch(() => {
                if (!this.$store.state.user.logined) {
                    this.clearLoginInfo();
                    if (this.$router.history.current.path !== "/") {
                        this.$router.push("/");
                    }
                }
            })
        },
        clearLoginInfo(){
            this.$store.state.user.logined = false;
            this.$store.state.user.userId = '';
            this.$store.state.user.userName = '';
            this.$store.state.user.role = '';
            this.$store.state.user.dept = '';
            this.$store.state.user.token = '';
            this.$store.state.user.loginToken = '';
            localStorage.removeItem('userId');
            localStorage.removeItem('userName');
            localStorage.removeItem('role');
            localStorage.removeItem('dept');
            localStorage.removeItem('token');
            localStorage.removeItem('loginToken');
            localStorage.removeItem('forceChangePwd');
        }
    }
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
</style>
